import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-3 px-6" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5 w-8/12" }
const _hoisted_4 = { class: "text-center" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import TabComponent from '@/components/TabComponent.vue';
import PageLoader from '@/components/PageLoader.vue';
import PagePagination from '@/components/PagePagination.vue';

import HmoAccreditations from '@/classes/HmoAccreditations'
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
// Data
const loader    = ref(false);
const showError = ref(false);
const errorMsg  = ref(null);

// Query
const searchText = ref();
const activeTab  = ref();
const goToPage   = ref();

// Page Renderer Data
const items       = ref(null);
const items_count = ref(0);
const query       = ref(null);


const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'Active',
        count: 0,
        href: '/contents/hmo-accreditation',
        allowed: true
    }
];

const headers: { text: string }[] = [
    { text: 'HMO Accreditation' },
    // { text: 'Date Created'}
];


const indexHmo = (data: string) => {
    loader.value = true;

    const pageNum = data?.match(/\d+/)[0];
    const queryString =  searchText.value ? `&query=${searchText.value}` : ''

    goToPage.value = data ? `page=${pageNum}` : 'page=1';

    HmoAccreditations.indexHmo(goToPage.value + queryString)
        .then((response: any) => {
            loader.value          = false;
            items.value           = response.data;
            items_count.value     = response.data.total
            query.value           = response.data.query
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

onMounted(() => indexHmo(goToPage.value) )


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "HMO Accreditations" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, {
          tabs: tabs,
          "button-items": true
        })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FilterComponent, {
          "sidebar-filters": false,
          "text-filters": false,
          search: searchText.value,
          "onUpdate:searchText": _cache[0] || (_cache[0] = (value) => (searchText.value = value)),
          "onUpdate:filters": _ctx.applyFilters,
          "custom-filters": activeTab.value !== 'activity_logs'
        }, null, 8, ["search", "onUpdate:filters", "custom-filters"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DataTable, {
          headers: headers,
          count: items.value?.total
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item) => {
              return (_openBlock(), _createElementBlock("tr", { key: item }, [
                _createElementVNode("td", _hoisted_3, _toDisplayString(item.hmo_name), 1),
                _createElementVNode("td", _hoisted_4, [
                  _createVNode(ActionButton, {
                    "edit-btn": "",
                    onClick: ($event: any) => (_unref(router).push(`/contents/hmo-accreditation/show/${item.hmo_id}`))
                  }, null, 8, ["onClick"])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["count"]),
        _createVNode(PagePagination, {
          class: "mb-6",
          items: items.value,
          onNextPage: indexHmo
        }, null, 8, ["items"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})